import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Select, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { addRelationshipManagersToOrg, getAllEmployees } from '@data'
import { User } from '@data/model'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { Clear } from '@material-ui/icons'
import { MakePrimaryButton, SelectedEmpoyee } from '@pages/Admin/Enquiry/ManageEnquiries/AssignEnquiry/AssignToEmployee'
import { Spacings } from '@styles'

const ClearIcon = styled(Clear)`
	cursor: pointer;
`

const CommoditySelectWrapper = styled.div`
	max-width: 25%;
	margin: 0 ${Spacings.SPACING_1B};
`

const EditOrgManagers = ({ orgDetails, update, getEmployees }) => {
	const dispatch = useDispatch()
	const [employees, setEmployees] = useState([])
	const [commodityList, setCommodityList] = useState(orgDetails?.commodity)
	const [selectedManagers, setSelectedManagers] = useState(orgDetails?.relationship_managers ?? [])

	const selectableEmployees = employees.filter((_e) => !_e.selected)
	let selectedEmployees = employees.filter((_e) => _e.selected)

	const alreadyAssignedUserIds = useMemo(() => {
		if (orgDetails?.relationship_managers && orgDetails?.relationship_managers?.length) {
			return orgDetails?.relationship_managers?.map((_rm) => _rm?.user_id)
		}
		return null
	}, [orgDetails])

	// const { primarySaleUser, primarySupplyUser } = useMemo(() => {
	// 	if (orgDetails)
	// 		if (orgDetails?.relationship_managers && orgDetails?.relationship_managers?.length) {
	// 			return {
	// 				primarySaleUser: orgDetails?.relationship_managers?.filter((_rm) => _rm?.is_primary),
	// 				primarySupplyUser: orgDetails?.relationship_managers?.filter((_rm) => _rm?.is_primary_supply),
	// 			}
	// 		}
	// 	return {}
	// }, [orgDetails])

	useEffect(() => {
		dispatch(showLoader(true))
		getAllEmployees()
			.then((response) => {
				let employees = response?.map((item) => new User(item)?.getUserDetails())
				// if (alreadyAssignedUserIds) {
				// 	employees = employees.map((_e) => {
				// 		if (alreadyAssignedUserIds.includes(_e.user_id)) {
				// 			_e.selected = true

				// 			if (primarySaleUser && primarySaleUser.find((item) => item.user_id === _e.user_id)) {
				// 				_e.isPrimary = true
				// 			}
				// 			if (primarySupplyUser && primarySupplyUser.find((item) => item.user_id === _e.user_id)) {
				// 				_e.isPrimarySupply = true
				// 			}
				// 			let _u = orgDetails?.relationship_managers?.find((_i) => _i.user_id === _e.user_id)
				// 			_e.commodity = _u?.commodity
				// 		}
				// 		return _e
				// 	})
				// }

				employees = employees.map((_e) => ({ ..._e, display_name_number: _e.full_name ?? _e.mobile_number }))
				setEmployees(employees)
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [orgDetails])

	const onSelectManager = (selectedEmpoyee) => {
		setSelectedManagers((_s) => [..._s, selectedEmpoyee])
	}

	const makePrimary = (userId, type, index) => {
		let _manager = selectedManagers[index]

		if (type === 'supply') {
			_manager.is_primary_supply = true
		} else {
			_manager.is_primary = true
		}
		selectedManagers[index] = _manager
		setSelectedManagers([...selectedManagers])
	}

	const removeHandler = (userId, index) => {
		setSelectedManagers((_s) => _s?.filter((item, idx) => idx !== index))
	}

	const assignHandler = () => {
		dispatch(showLoader(true))

		addRelationshipManagersToOrg(orgDetails?.organisation_id, selectedManagers)
			.then((response) => {
				update()
				dispatch(showToast(true, strings('msg_relationship_managers_edited_success'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				console.log(error)
				let erro_msg = error?.erro_msg ?? strings('msg_relationship_managers_edited_failed')
				dispatch(showToast(true, erro_msg, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				dispatch(toggleDrawer(false))
			})
	}

	const selectEmployeeCommodity = (employee, commodity, index) => {
		setSelectedManagers((_data) =>
			_data.map((item, idx) => {
				if (idx === index) {
					return { ...item, commodity: commodity }
				} else {
					return item
				}
			})
		)
	}

	const renderSelectedEmpoyees = () => {
		return selectedManagers?.map((_employee, index) => (
			<SelectedEmpoyee key={`employee-${_employee?.user_id}`}>
				<div>
					<span>
						<b>{_employee.full_name}</b>
					</span>
					<span>
						<small>{_employee.mobile_number}</small>
					</span>
				</div>
				{!_employee?.is_primary && (
					<MakePrimaryButton onClick={() => makePrimary(_employee.user_id, 'sales', index)}>
						{strings('sales', 'primary')}
					</MakePrimaryButton>
				)}
				{!_employee?.is_primary_supply && (
					<MakePrimaryButton onClick={() => makePrimary(_employee.user_id, 'supply', index)}>
						{strings('supply', 'primary')}
					</MakePrimaryButton>
				)}
				{_employee?.is_primary && <MakePrimaryButton showAsText>{strings('primary')}</MakePrimaryButton>}
				{_employee?.is_primary_supply && (
					<MakePrimaryButton showAsText isSupply>
						{strings('supply', 'primary')}
					</MakePrimaryButton>
				)}
				<CommoditySelectWrapper>
					<Select
						id='select-commodity'
						placeholder='Select Commodity'
						label='Commodity'
						data={commodityList}
						primaryKey='commodity_id'
						displayKey='commodity_name'
						value={commodityList?.find((item) => item.commodity_id === _employee?.commodity?.commodity_id) ?? {}}
						onChange={(val) => selectEmployeeCommodity(_employee, val, index)}
					/>
				</CommoditySelectWrapper>
				{<ClearIcon fontSize='small' onClick={() => removeHandler(_employee.user_id, index)} />}
			</SelectedEmpoyee>
		))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<div>
					<Select
						id='employee-select'
						placeholder={'Select Employee'}
						data={selectableEmployees}
						displayKey='display_name_number'
						primaryKey='user_id'
						value={{}}
						onChange={onSelectManager}
						label={strings('select_employee_s')}
					/>
					{renderSelectedEmpoyees()}
				</div>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small uppercase type='primary' disabled={false} onClick={assignHandler}>
					{strings('assign')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default EditOrgManagers
